import React, { useEffect, useRef } from 'react';

function AlbumFilterPopup({ filters, recordLabels = [], onFilterChange, onReset, onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div className="popup-dropdown filter-dropdown" ref={containerRef} style={{ width: '320px' }}>
      <div className="popup-dropdown-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' }}>
        <span className="popup-title" style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Filters</span>
        <button type="button" className="reset-all-btn" onClick={onReset} style={{ background: 'none', border: 'none', color: '#ef4444', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}>
          Reset All
        </button>
      </div>

      <div className="filter-groups-list" style={{ marginTop: '14px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {/* Record Label Filter Section */}
        <div className="filter-popup-group">
          <div className="filter-group-title" style={{ fontSize: '13px', fontWeight: '600', color: '#64748b', marginBottom: '8px' }}>
            Record Label
          </div>
          <div className="filter-group-options" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', maxHeight: '160px', overflowY: 'auto' }}>
            {recordLabels.length > 0 ? (
              recordLabels.map((lbl) => {
                const isSelected = String(filters.labelId) === String(lbl.id);
                return (
                  <button
                    key={lbl.id}
                    type="button"
                    className={`filter-badge-btn ${isSelected ? 'active' : ''}`}
                    onClick={() => {
                      if (isSelected) {
                        onFilterChange('labelId', null);
                      } else {
                        onFilterChange('labelId', lbl.id);
                      }
                    }}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '500',
                      border: '1px solid #e2e8f0',
                      background: isSelected ? '#3b82f6' : '#ffffff',
                      color: isSelected ? '#ffffff' : '#475569',
                      cursor: 'pointer',
                      transition: 'all 0.15s ease'
                    }}
                  >
                    {lbl.name}
                  </button>
                );
              })
            ) : (
              <span style={{ fontSize: '12px', color: '#94a3b8' }}>No record labels available</span>
            )}
          </div>
        </div>

        {/* Track Count Filter Section */}
        <div className="filter-popup-group">
          <div className="filter-group-title" style={{ fontSize: '13px', fontWeight: '600', color: '#64748b', marginBottom: '8px' }}>
            Track Count
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <input 
              type="number" 
              min="0"
              placeholder="e.g. 12"
              value={filters.trackCount || ''}
              onChange={(e) => onFilterChange('trackCount', e.target.value ? e.target.value : null)}
              style={{
                width: '100%',
                padding: '8px 12px',
                borderRadius: '8px',
                border: '1px solid #cbd5e1',
                fontSize: '13px',
                outline: 'none'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlbumFilterPopup;
